module.exports = __webpack_public_path__ + "static/media/ordenVideo.c92d408b.jpg";